// Styles for ConsentCheckListItem go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledConsentsListItem = styled.div`
  &.m-consent-list {
    margin: ${toRem(32)} 0;
    .legal-text-link {
      margin: ${toRem(8)} 0;
      font-size: ${toRem(14)};
      font-weight: 500;
    }
    a {
      font-size: ${toRem(14)};
      font-weight: bold;
    }
  }
`;
